'use client';
import React from 'react';
import { styled } from '../stitches.config.js';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { Separator } from './Separator.js';

const Tabs = styled(TabsPrimitive.Root, {
    display: 'flex',
    '&[data-orientation="horizontal"]': {
        flexDirection: 'column',
    },
});
const TabsTrigger = styled(TabsPrimitive.Trigger, {
    flexShrink: 0,
    height: '$5',
    display: 'inline-flex',
    lineHeight: 1,
    fontSize: '$1',
    px: '$2',
    userSelect: 'none',
    outline: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    color: '$gray11',
    border: '1px solid transparent',
    borderTopLeftRadius: '$2',
    borderTopRightRadius: '$2',
    zIndex: '10',
    '@hover': {
        '&:hover': {
            color: '$hiContrast',
        },
    },
    '&[data-state="active"]': {
        color: '$hiContrast',
        borderColor: '$gray6',
        borderBottomColor: 'transparent',
    },
    '&[data-orientation="vertical"]': {
        justifyContent: 'flex-start',
        borderTopRightRadius: 0,
        borderBottomLeftRadius: '$2',
        borderBottomColor: 'transparent',
        '&[data-state="active"]': {
            borderBottomColor: '$gray6',
            borderRightColor: 'transparent',
        },
    },
});
const StyledTabsList = styled(TabsPrimitive.List, {
    flexShrink: 0,
    display: 'flex',
    '&:focus': {
        outline: 'none',
        boxShadow: 'inset 0 0 0 1px $gray8, 0 0 0 1px $gray8',
    },
    '&[data-orientation="vertical"]': {
        flexDirection: 'column',
        boxShadow: 'inset -1px 0 0 $gray6',
    },
});
const TabsList = React.forwardRef((props, forwardedRef) => (React.createElement(React.Fragment, null,
    React.createElement(StyledTabsList, Object.assign({}, props, { ref: forwardedRef })),
    React.createElement(Separator, null))));
const TabsContent = styled(TabsPrimitive.Content, {
    flexGrow: 1,
    '&:focus': {
        outline: 'none',
        boxShadow: 'inset 0 0 0 1px $gray8, 0 0 0 1px $gray8',
    },
});

export { Tabs, TabsContent, TabsList, TabsTrigger };
